/**
 * Formateadores comunes — moneda, fechas, etc. en español de México.
 */

const MXN = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2,
});

const MXN_SHORT = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  maximumFractionDigits: 0,
});

export function formatMxnCents(cents: number): string {
  return MXN.format(cents / 100);
}

export function formatMxnCentsShort(cents: number): string {
  return MXN_SHORT.format(Math.round(cents / 100));
}

const DATE = new Intl.DateTimeFormat("es-MX", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

export function formatDate(input: string | number | Date): string {
  if (typeof input === "number") return DATE.format(new Date(input * 1000));
  if (typeof input === "string") {
    // Para strings de fecha pura "YYYY-MM-DD" parseamos manualmente para
    // evitar el bug clásico: new Date("2026-05-09") se interpreta como UTC
    // midnight, y al formatear en zona horaria de México (UTC-6) baja al
    // día anterior. Tratamos la fecha como local-naive: el día que ves es
    // el día que se guardó.
    const m = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) {
      const [, y, mo, d] = m;
      return DATE.format(new Date(parseInt(y!, 10), parseInt(mo!, 10) - 1, parseInt(d!, 10)));
    }
    return DATE.format(new Date(input));
  }
  return DATE.format(input);
}

export function formatPeriod(period: string): string {
  // YYYY-MM → "Mayo 2026"
  const [y, m] = period.split("-");
  if (!y || !m) return period;
  const d = new Date(parseInt(y, 10), parseInt(m, 10) - 1, 1);
  return d.toLocaleDateString("es-MX", { month: "long", year: "numeric" });
}

export function shiftPeriod(period: string, delta: number): string {
  const [y, m] = period.split("-").map((s) => parseInt(s, 10));
  if (!y || !m) return period;
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
